import React, { useEffect, useState } from 'react';
import { setEventData } from './eventSlice'; // adjust path as needed
import { useDispatch } from 'react-redux';
import config from '../../config';
const APIData = () => {
  const [parsedData, setParsedData] = useState(null);
  const [loading, setLoading] = useState(true);

  const eventCode = '2222'; // Replace with actual code or prop

  const dispatch = useDispatch();
console.log("api url",config.apibaseUrlBackend)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${config.apibaseUrlBackend}/events/${eventCode}`);
        if (!response.ok) throw new Error('Failed to fetch data');
        
        const json = await response.json();
        const parsedJsonData = JSON.parse(json[0]?.jsonData);
        setParsedData(parsedJsonData);
        dispatch(setEventData(parsedJsonData));
        
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [eventCode, dispatch]);
  if (loading) return <div>Loading...</div>;
  console.log("parsedData",parsedData)

  return (
    <div>
    
    </div>
  );
};

export default APIData;
